module.exports = __webpack_public_path__ + "static/media/2_euro_free_991_90.fe5fda12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2_euro_free_991_90.jpg
// module id = 62
// module chunks = 0